module.exports = __webpack_public_path__ + "media/images/remember-logo-full-6f7103f0593e4c5f0239f6dc54092a3a.png";